import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import { BsFillCaretDownFill, BsFillCaretUpFill } from 'react-icons/bs';
import IconWrapper from '../IconWrapper';
import './style.scss';

interface NavAccordionHeaderProps {
  children: ReactNode;
  active?: boolean;
  onClick?: () => void;
  icon?: ReactElement;
  showText?: boolean;
}

const NavAccordionHeader = ({
  children,
  active,
  onClick,
  icon,
  showText
}: NavAccordionHeaderProps) => {
  const anchorClass = classNames({
    'nav-link': true,
    'text-white': true,
    'accordion-container': true,
    'cursor-pointer': true
    // active,
  });

  const handleClick = () => {
    if (showText) {
      onClick?.();
    }
  };

  return (
    <div className={anchorClass} onClick={handleClick}>
      {icon ? (
        <IconWrapper size={23} color="text-white">
          {icon}
        </IconWrapper>
      ) : null}
      {showText && children}
      {showText && (active ? <BsFillCaretUpFill /> : <BsFillCaretDownFill />)}
    </div>
  );
};

export default NavAccordionHeader;
